import { useState, useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import { useMsal } from '@azure/msal-react';
import { fetchAuthorized } from '../../utils/fetchAuthorized';
import { AddEnterprise } from './AddEnterprise';
import Select from 'react-select';
import { CreateNewSelect } from '../controls/CreateNewSelect';

const clientFunctions = [
    { value: "Business Unit", label: "Business Unit" },
    { value: "Commercial & Sales", label: "Commercial & Sales" },
    { value: "Corporate & Shared Services", label: "Corporate & Shared Services" },
    { value: "Customer Service", label: "Customer Service" },
    { value: "Enterprise", label: "Enterprise" },
    { value: "Finance", label: "Finance" },
    { value: "Human Resources", label: "Human Resources" },
    { value: "Information Technology", label: "Information Technology" },
    { value: "Legal", label: "Legal" },
    { value: "Marketing", label: "Marketing" },
    { value: "Operations", label: "Operations" },
    { value: "Research and Development", label: "Research and Development" },
    { value: "Supply Chain & Procurement", label: "Supply Chain & Procurement" },
    { value: "Other", label: "Other" }
];
const functionSizes = [
    { value: "50,000+", label: "50,000+" },
    { value: "25,000-49,999", label: "25,000-49,999" },
    { value: "10,000-24,999", label: "10,000-24,999" },
    { value: "5,000-9,999", label: "5,000-9,999" },
    { value: "2,500-4,999", label: "2,500-4,999" },
    { value: "1,500-2,499", label: "1,500-2,499" },
    { value: "500-1,500", label: "500-1,500" },
    { value: "250-499", label: "250-499" },
    { value: "100-249", label: "100-249" },
    { value: "50-99", label: "50-99" },
    { value: "1-49", label: "1-49" }
];
const geographyOptions = [
    { value: "NA (North America)", label: "NA (North America)" },
    { value: "APAC (Asia-Pacific, Austrailia, & New Zealand)", label: "APAC (Asia-Pacific, Austrailia & New Zealand)" },
    { value: "EMEIA (Europe, Middle East, India, and Africa)", label: "EMEIA (Europe, Middle East, India, and Africa)" },
    { value: "LATAM", label: "LATAM (Latin America)" }
];
const problems = [
    { value: "Optimization", label: "Optimization" },
    { value: "M&A & Spin Off", label: "M&A & Spin Off" },
    { value: "Growth", label: "Growth" },
    { value: "Efficiency", label: "Efficiency" }
];

export function AddClient(props) {
    const { instance } = useMsal();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [show, setShow] = useState(false);
    const [name, setName] = useState("");
    const [enterprises, setEnterprises] = useState([]);
    const [enterprise, setEnterprise] = useState();
    const [clientFunction, setClientFunction] = useState();
    const [functionSize, setFunctionSize] = useState();
    const [geographies, setGeographies] = useState([]);
    const [problem, setProblem] = useState();

    useEffect(() => {
        const getEnterprises = async () => {
            try {
                if (enterprises && enterprises.length > 0)
                    return;
                const response = await fetchAuthorized(instance, `${process.env.REACT_APP_API_URL}enterprises`);
                if (!response.ok) {
                    throw new Error('Could not retrieve enterprises.');
                }
                const data = await response.json();
                setEnterprises(data);
            } catch (error) {
                setError("Could not retreive enterprises.");
            } finally {
                setLoading(false);
            }
        };
        getEnterprises();
    }, [instance]);

    const handleAddEnterprise = (newEnterprise) => {
        newEnterprise = { ...newEnterprise, label: newEnterprise.name };
        setEnterprises((enterprises) => [...enterprises, newEnterprise]);
        setEnterprise(newEnterprise);
    }
    const handleCancelAddEnterprise = () => setEnterprise(null);

    const handleClose = () => setShow(false);
    const handleSave = async (event) => {
        event.preventDefault();
        setShow(false);

        //check for existing client
        if (props.clients.find(a => a.name === name))
            throw new Error(`Could not add client. ${name} already exists.`);

        try {
            var params = {
                method: "POST",
                body: JSON.stringify({
                    name,
                    createdDate: new Date(),
                    enterpriseId: enterprise.id,
                    enterpriseName: enterprise.name,
                    employees: [],
                    function: clientFunction.value,
                    functionSize: functionSize.value,
                    geographies: geographies.map(a => a.value),
                    problem: problem.value
                }),
                headers: {
                    "Content-type": "application/json; charset=UTF-8",
                }
            };
            const response = await fetchAuthorized(instance, `${process.env.REACT_APP_API_URL}Clients`, params);
            if (!response.ok) {
                throw new Error('Could not add Client.');
            }
            const data = await response.json();
            props.onAddClient([data, ...props.clients]);
        } catch (error) {
            setError(error.message);
        } finally {
            setLoading(false);
        }
    };
    //const items = [ "1", "2", "3", "4", "5", "6", "7", "8", "9", "10" ];

    const enterpriseOptions = enterprises.map(enterprise => ({ ...enterprise, value: enterprise.name, label: enterprise.name }));
    //enterpriseOptions.push(...items.map(a => { return ({ value: a, label: a }); }));

    if (error)
        return (<p>Error: {error}</p>)

    if (props.modal) {
        return (
            <>
                <div>
                    <Button variant="primary" disabled={loading} className="mt-3" onClick={() => setShow(true)}>
                        Add Design
                    </Button>
                </div>

                {!loading && (
                    <Modal variant="large" show={show} onHide={handleClose}>
                        <Modal.Header closeButton>
                            <Modal.Title>Add Design</Modal.Title>
                        </Modal.Header>
                        {enterprise?.value === 'create_new' &&
                            <Modal.Body>
                                <Form.Group controlId="enterprise" className="mb-3">
                                    <Form.Label>Enterprise: </Form.Label>
                                    <CreateNewSelect
                                        aria-label="enterprise"
                                        placeholder="Select Enterprise"
                                        required
                                        options={enterpriseOptions}
                                        value={enterprise}
                                        onChange={(enterprise) => setEnterprise(enterprise)}
                                        createNewLabel="+ Create New Enterprise"
                                    />
                                </Form.Group>

                                <AddEnterprise
                                    enterprises={enterprises}
                                    handleAddEnterprise={handleAddEnterprise}
                                    handleCancelAddEnterprise={handleCancelAddEnterprise}
                                />
                            </Modal.Body>
                        }
                        {(!enterprise || enterprise?.value !== 'create_new') &&
                            <Form onSubmit={handleSave}>
                                <Modal.Body>
                                    <Form.Group controlId="enterprise" className="mb-3">
                                        <Form.Label>Enterprise</Form.Label>
                                        <CreateNewSelect
                                            aria-label="enterprise"
                                            placeholder="Select Enterprise"
                                            required
                                            options={enterpriseOptions}
                                            value={enterprise}
                                            onChange={(enterprise) => setEnterprise(enterprise)}
                                            createNewLabel="+ Create New Enterprise"
                                        />
                                    </Form.Group>
                                    <Form.Group controlId="name" className="mb-3">
                                        <Form.Label>Design Name</Form.Label>
                                        <Form.Control type="text" required onChange={(event) => setName(event.target.value)} placeholder="Design Name" />
                                    </Form.Group>
                                    <Form.Group controlId="function" className="mb-3">
                                        <Form.Label>Function</Form.Label>
                                        <Select
                                            aria-label='function'
                                            placeholder="Select Function"
                                            required
                                            options={clientFunctions}
                                            value={clientFunction}
                                            onChange={(clientFunction) => setClientFunction(clientFunction)}
                                        />
                                        <i style={{ fontSize: 12, color: '#333' }}>If this is for the entire org, select Enterprise.</i>
                                    </Form.Group>
                                    <Form.Group controlId="functionSize" className="mb-3">
                                        <Form.Label>Function Size</Form.Label>
                                        <Select
                                            aria-label='functionSize'
                                            placeholder="Select Function Size"
                                            required
                                            options={functionSizes}
                                            value={functionSize}
                                            onChange={(functionSize) => setFunctionSize(functionSize)}
                                        />
                                    </Form.Group>
                                    <Form.Group controlId="geographies" className="mb-3">
                                        <Form.Label>Geography</Form.Label>
                                        <Select
                                            isMulti
                                            aria-label='geographies'
                                            placeholder="Select Geography"
                                            required
                                            options={geographyOptions}
                                            value={geographies}
                                            onChange={(geography) => setGeographies(geography)}
                                        />
                                    </Form.Group>
                                    <Form.Group controlId="problem" className="mb-3">
                                        <Form.Label>Problem To Solve</Form.Label>
                                        <Select
                                            aria-label='problem'
                                            placeholder="Select Problem To Solve"
                                            required
                                            options={problems}
                                            value={problem}
                                            onChange={(problem) => setProblem(problem)}
                                        />
                                    </Form.Group>
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button variant="secondary" onClick={handleClose}>
                                        Close
                                    </Button>
                                    <Button variant="primary" type="submit">
                                        Save
                                    </Button>
                                </Modal.Footer>
                            </Form>
                        }
                    </Modal>
                )}
            </>
        );
    }

    return !loading && (
        <div>
            {enterprise?.value === 'create_new' &&
                <div>
                    <Form.Group controlId="enterprise" className="mb-3">
                        <Form.Label>Enterprise</Form.Label>
                        <CreateNewSelect
                            aria-label="enterprise"
                            placeholder="Select Enterprise"
                            required
                            options={enterpriseOptions}
                            value={enterprise}
                            onChange={(enterprise) => setEnterprise(enterprise)}
                            createNewLabel="+ Create New Enterprise"
                        />
                    </Form.Group>

                    <AddEnterprise
                        enterprises={enterprises}
                        setEnterprises={setEnterprises}
                        handleAddEnterprise={handleAddEnterprise}
                        handleCancelAddEnterprise={handleCancelAddEnterprise}
                    />
                </div>
            }
            {(!enterprise || enterprise?.value !== 'create_new') &&
                <Form onSubmit={handleSave}>
                    <Form.Group controlId="enterprise" className="mb-3">
                        <Form.Label>Enterprise</Form.Label>
                        <CreateNewSelect
                            aria-label="enterprise"
                            placeholder="Select Enterprise"
                            required
                            options={enterpriseOptions}
                            value={enterprise}
                            onChange={(enterprise) => setEnterprise(enterprise)}
                            createNewLabel="+ Create New Enterprise"
                        />
                    </Form.Group>
                    <Form.Group controlId="name" className="mb-3">
                        <Form.Label>Design Name</Form.Label>
                        <Form.Control type="text" required onChange={(event) => setName(event.target.value)} placeholder="Design Name" />
                    </Form.Group>
                    <Form.Group controlId="function" className="mb-3">
                        <Form.Label>Function</Form.Label>
                        <Select
                            aria-label='function'
                            placeholder="Select Function"
                            required
                            options={clientFunctions}
                            value={clientFunction}
                            onChange={(clientFunction) => setClientFunction(clientFunction)}
                        />
                        <i style={{ fontSize: 12, color: '#333' }}>If this is for the entire org, select Enterprise.</i>
                    </Form.Group>
                    <Form.Group controlId="functionSize" className="mb-3">
                        <Form.Label>Function Size</Form.Label>
                        <Select
                            aria-label='functionSize'
                            placeholder="Select Function Size"
                            required
                            options={functionSizes}
                            value={functionSize}
                            onChange={(functionSize) => setFunctionSize(functionSize)}
                        />
                    </Form.Group>
                    <Form.Group controlId="geography" className="mb-3">
                        <Form.Label>Geography</Form.Label>
                        <Select
                            isMulti
                            aria-label='geography'
                            placeholder="Select Geography"
                            required
                            options={geographyOptions}
                            value={geographies}
                            onChange={(geography) => setGeographies(geography)}
                        />
                    </Form.Group>
                    <Form.Group controlId="problem" className="mb-3">
                        <Form.Label>Problem To Solve</Form.Label>
                        <Select
                            aria-label='problem'
                            placeholder="Select Problem To Solve"
                            required
                            options={problems}
                            value={problem}
                            onChange={(problem) => setProblem(problem)}
                        />
                    </Form.Group>

                    <Button variant="primary" type="submit">
                        Save
                    </Button>
                </Form>
            }
        </div>
    );
}